import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[ttMenuItem]',
  standalone: true,
})
export class MenuItemDirective {
  @HostBinding('class.tt-menu-item') public hostCls = true;
  @Input() public disabled = false;

  @HostBinding('class.tt-menu-item--disabled')
  public get isDisabled() {
    return this.disabled;
  }
}
